<template>
  <div>
    <b-modal v-model="isError" :active="isError" :width="1000" full-screen height="1500"
      scroll="keep" :on-cancel="
        () => {
          isError = false
        }
      ">
      <div class="card">
        <div class="card-content">
          <header class="modal-card-head">
            <p class="modal-card-title m-b-0">
              <span><img width="120px" :src="tots_image" /></span>
            </p>

            <button class="delete" type="button" @click="closePopUp"></button>
          </header>

          <template>
            <div>
              <section class="container section page-header section is-main-section">
                <error-page></error-page>
              </section>
            </div>
          </template>
        </div>
      </div>
    </b-modal>
    <b-modal v-model="isSuccess" :active="isSuccess" :width="1000" full-screen height="1500"
      scroll="keep" :on-cancel="
        () => {
          isSuccess = false
        }
      ">
      <div class="card">
        <div class="card-content">
          <header class="modal-card-head">
            <p class="modal-card-title m-b-0">
              <span><img width="120px" :src="tots_image" /></span>
            </p>

            <button class="delete" type="button" @click="closePopUp"></button>
          </header>

          <template>
            <div>
              <section class="container section page-header section is-main-section">
                <thank-you :paymentOrderID="paymentOrderID" noOfPage="1" :isPrint="isPrint">
                </thank-you>
              </section>
            </div>
          </template>
        </div>
      </div>
    </b-modal>
    <v-container v-if="studentInfo">
      <div v-if="studentInfo">
        <v-row key="1">
          <v-col cols="12" md="2" lg="2" xl="2" align="center">
            <v-img :src="tots_image" width="120"> </v-img>
          </v-col>
          <v-col cols="12" md="2" sm="4">
            <div class="d-flex justify-space-between caption ">
              <div>
                <div class="grey--text text-subtitle-2  mb-1">
                  Enquiry Code
                </div>
                <div class="text-button mb-1 " v-text="studentInfo.enquiryCode"></div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="2" sm="4">
            <div class="d-flex justify-space-between caption">
              <div>
                <div class="grey--text text-subtitle-2 mb-1">
                  Student Name
                </div>
                <div class="text-button mb-1"
                  v-text="studentInfo.studentFirstName + ' ' + studentInfo.studentLastName"></div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="2" sm="4">
            <div class="d-flex justify-space-between caption">
              <div>
                <div class="grey--text text-subtitle-2 mb-1">
                  Franchisee Name
                </div>
                <div class="text-button mb-1" v-text="studentInfo.franchisee.companyName"></div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="2" sm="4">
            <div class="d-flex justify-space-between caption">
              <div>
                <div class="grey--text text-subtitle-2 mb-1">
                  Academic Year
                </div>
                <div class="text-button mb-1" v-text="studentInfo.academicYear.academicYear"></div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="2" sm="4">
            <div class="d-flex justify-space-between caption">
              <div>
                <div class="grey--text text-subtitle-2 mb-1">
                  Class
                </div>
                <div class="text-button mb-1" v-text="studentInfo.class"></div>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row key="2">
          <!-- <v-col cols="12" md="2" lg="2" xl="2" align="center"> </v-col> -->
          <v-col cols="12" md="2" sm="4">
            <div class="d-flex justify-space-between caption">
              <div>
                <div class="grey--text text-subtitle-2 mb-1">
                  Parent / Guardian Name
                </div>
                <div class="text-button mb-1" v-text="studentInfo.fatherName"></div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="2" sm="4">
            <div class="d-flex justify-space-between caption">
              <div>
                <div class="grey--text text-subtitle-2 mb-1">
                  Parent / Guardian Mobile
                </div>
                <div class="text-button mb-1" v-text="studentInfo.fatherMobile"></div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <div class="d-flex justify-space-between caption">
              <div>
                <div class="grey--text text-subtitle-2 mb-1">
                  Parent / Guardian Email
                </div>
                <div class="text-button mb-1" v-text="studentInfo.fatherEmailID"></div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="2" sm="4">
            <div class="d-flex justify-space-between caption">
              <div>
                <div class="grey--text text-subtitle-2 mb-1">
                  Student Gender
                </div>
                <div v-if="studentInfo.gender ==='Female' || studentInfo.gender ==='FEMALE'"
                  class="text-button mb-1"
                  v-text="studentInfo && studentInfo.gender && studentInfo.gender ==='Female' ? 'Girl' : '-'||studentInfo && studentInfo.gender && studentInfo.gender ==='FEMALE' ? 'Girl' : '-'">
                </div>
                <div v-if="studentInfo.gender ==='Male' || studentInfo.gender ==='MALE'"
                  class="text-button mb-1"
                  v-text="studentInfo && studentInfo.gender && studentInfo.gender ==='Male' ? 'Boy' : '-' || studentInfo && studentInfo.gender && studentInfo.gender ==='MALE' ? 'Boy' : '-'">
                </div>
                <div v-if="studentInfo.gender === null" class="text-button mb-1">-</div>
                <div v-if="studentInfo.gender === ''" class="text-button mb-1">-</div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="2" sm="4">
            <div class="d-flex justify-space-between caption">
              <div>
                <div class="grey--text text-subtitle-2 mb-1">
                  Section / Division
                </div>
                <div class="text-button mb-1"
                  v-text="studentInfo.section ? studentInfo.section : '-'"></div>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row key="3">
          <v-col cols="12">
            <template>
              <v-row>
                <v-col cols="12" lg="12" sm="12">
                  <v-data-table :headers="headers" :items="feeTypeGroup" :single-expand="true"
                    show-expand hide-default-footer class="elevation-1" item-key="feeTypeName">
                    <template v-slot:top>
                      <v-toolbar flat color="warning lighten-3" class="d-flex justify-center">
                        <v-toolbar-title>Fee Structure (In Installments)</v-toolbar-title>
                      </v-toolbar>
                    </template>
                    <template v-slot:item.position="{ item }">
                      <v-text-field v-model="item.position" readonly class="centered-input">
                        <v-icon slot="append" color="green"
                          @click="changeInstallments('plus', item)">
                          mdi-plus
                        </v-icon>
                        <v-icon slot="prepend" color="red"
                          @click="changeInstallments('minus', item)">
                          mdi-minus
                        </v-icon>
                      </v-text-field>
                    </template>

                    <template v-slot:expanded-item="{ headers, item }">
                      <td :colspan="headers.length" class="pb-4 pt-4">
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-center">Pay Now</th>
                                <th class="text-center">
                                  Installment Name
                                </th>
                                <th class="text-center">
                                  Amount
                                </th>
                                <th class="text-center" v-if="isConcession">
                                  Concession Amount
                                </th>
                                <th class="text-center">
                                  Amount Due
                                </th>

                                <th class="text-center" v-if="isGST && !isIGST">
                                  CGST Amount
                                </th>

                                <th class="text-center" v-if="isGST && !isIGST">
                                  SGST Amount
                                </th>

                                <th class="text-center" v-if="isGST && isIGST">
                                  IGST Amount
                                </th>

                                <th class="text-center">
                                  Amount To Pay
                                </th>
                                <th class="text-center">
                                  Due Date
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="element in item.installments" :key="element.id">
                                <td align="center">
                                  <v-checkbox class="shrink mr-0 mt-0" readonly :value="true"
                                    v-model="element.isChecked" :disabled="element.isCompulsory"
                                    hide-details></v-checkbox>
                                </td>
                                <td align="center" justify="center">{{ element.name }}</td>
                                <td align="center" justify="center">
                                  {{ Number(element.amount).toFixed(2) }}</td>
                                <td align="center" justify="center" v-if="isConcession">
                                  {{ Number(element.amountConcession).toFixed(2) }}</td>
                                <td align="center" justify="center">
                                  {{ Number(element.amountDue).toFixed(2) }}</td>
                                <td align="center" justify="center" v-if="isGST && !isIGST">
                                  {{ Number(element.cGSTAmt).toFixed(2) }}</td>
                                <td align="center" justify="center" v-if="isGST && !isIGST">
                                  {{ Number(element.sGSTAmt).toFixed(2) }}</td>
                                <td align="center" justify="center" v-if="isGST && isIGST">
                                  {{ Number(element.iGSTAmt).toFixed(2) }}</td>
                                <td align="center" justify="center">
                                  {{ Number(element.payableAmt).toFixed(2) }}</td>
                                <td align="center" justify="center">
                                  {{ new Date(element.dueDate).toLocaleDateString() }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </td>
                    </template>
                    <template v-slot:body.append>
                      <tr>
                        <th class="text-center text-subtitle-2" colspan="2">Totals</th>
                        <th class="text-center text-subtitle-2"><span
                            class="mdi mdi-currency-inr"></span>{{ totalAmount.toFixed(2) }}</th>
                        <th class="text-center text-subtitle-2" v-if="isGST && isIGST"><span
                            class="mdi mdi-currency-inr"></span>{{ totalIGST.toFixed(2) }}</th>
                        <th class="text-center text-subtitle-2" v-if="isGST && !isIGST"><span
                            class="mdi mdi-currency-inr"></span>{{ totalCGST.toFixed(2) }}</th>
                        <th class="text-center text-subtitle-2" v-if="isGST && !isIGST"><span
                            class="mdi mdi-currency-inr"></span>{{ totalSGST.toFixed(2) }}</th>
                        <th class="text-center text-subtitle-2" v-if="isConcession"><span
                            class="mdi mdi-currency-inr"></span>{{ totalConcession.toFixed(2) }}
                        </th>
                        <th class="text-center text-subtitle-2"><span
                            class="mdi mdi-currency-inr"></span>{{ totalAmountDue.toFixed(2) }}</th>
                        <th class="text-center text-subtitle-2">
                          <v-btn success icon-right="arrow-right-bold" id="rzp-button1"
                            color="success" @click="Pay">
                            Pay (<span
                              class="mdi mdi-currency-inr"></span>{{ Number(totalAmountToPay).toFixed(2) }})
                          </v-btn>
                        </th>
                      </tr>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </template>
          </v-col>
        </v-row>
      </div>
      <v-snackbar v-model="snackbar" :timeout="snackbarTimeout">
        {{ snackbarMsg || 'Welcome' }}

        <template v-slot:action="{ attrs }">
          <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import constants from '@/utils/constants'
import _ from 'lodash'
import ThankYou from '../../components/Fees/payment/thankYou.vue'
import ErrorPage from '../../components/Fees/payment/error.vue'

export default {
  name: 'servicePlanInstallmentList',
  components: {
    ThankYou,
    ErrorPage
  },
  props: ['referenceID'],
  data () {
    return {
      isPrint: true,
      sendCaptureRespos: [],
      isRecipt: false,
      disable: true,
      selectedRows: [],
      selecteditem: '',
      dialog: false,
      snackbar: false,
      limitCallBack: 0,
      snackbarMsg: '',
      snackbarTimeout: 2000,
      headers: this.getHeaders(),
      tots_image: `${constants.RAZORPAY.TOTS_IMAGE}`,
      paginated: false,
      gstType: 'IGST',
      isGST: false,
      isIGST: true,
      isConcession: false,
      loadingComponent: null,
      totalAmount: 0,
      totalAmountDue: 0,
      totalConcession: 0,
      totalAmountToPay: 0,
      totalCGST: 0,
      totalSGST: 0,
      totalIGST: 0,
      checkedRows: [],
      isSuccess: false,
      isError: false,
      isSelected: '',
      feeSelected: [],
      feeTypeGroup: [],
      sumArray: [],
      breakUpData: [],
      feeTypeNaming: '',
      studentInfo: null,
      orderID: '',
      paymentOrderID: ''
    }
  },
  beforeCreate () {
    let recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', `${constants.RAZORPAY.JS}`)
    document.head.appendChild(recaptchaScript)
  },
  async created () {
    window.addEventListener('beforeunload', this.beforePageDestroyed)
    window.addEventListener('unload', this.beforePageDestroyed)
    await this.getAllInfo()
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.beforePageDestroyed)
    window.removeEventListener('unload', this.beforePageDestroyed)
  },
  methods: {
    beforePageDestroyed: async function (e) {
      console.log('beforePageDestroyedPayment ONINE')
      if (this.orderID) {
        e.returnValue = ''
        await this.reject().catch((err) => {
          console.log(err)
        })
        e.preventDefault()
        e.returnValue = false // Seems require this for Chrome
      }
    },

    reject: async function () {
      console.log(this.orderID)
      if (!this.orderID) {
        return
      }
      try {
        this.isLoading = true
        await http.patch(`${constants.API_URL}/api/payments/online/reject/order`, { orderID: this.orderID })
        this.isLoading = false

        this.orderID = ''

        this.$dialog.info({
          text: `Online Payment Rejected !!`,
          title: 'Rejected'
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message

        console.log('error in fetching data : ', errorMessage)

        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    closePopUp () {
      console.log('triggered!!')
      this.isSuccess = false
      window.location.href = constants.FRONTEND
    },
    openSnackbar (msg) {
      if (!this.snackbar) {
        this.snackbarMsg = msg
        this.snackbar = true
        this.limitCallBack--
      } else {
        // Usage!
        if (this.limitCallBack < 1) {
          this.limitCallBack++
          setTimeout(this.openSnackbar(msg), this.snackbarTimeout)
        }
      }
    },
    changeInstallments: function (type, item) {
      if (type === 'plus') {
        if (item.position >= item.maxPosition) {
          item.position = item.maxPosition
          this.openSnackbar('All due installments are selected.')
        } else {
          item.position = item.position + 1
        }
      } else {
        if (item.position <= item.minPosition) {
          item.position = item.minPosition
          this.openSnackbar('Minimum due till dates installments are selected.')
        } else {
          item.position = item.position - 1
        }
      }
      this.calculatePayAmount()
    },
    getHeaders () {
      let header = [
        { text: 'Fee Type', value: 'feeTypeName', align: 'center' },
        { text: 'Installments', value: 'position', align: 'center', width: 150 },
        { text: 'Amount', value: 'totalAmount', align: 'center' }
      ]

      if (this.isConcession) {
        header.push({ text: 'Concession Amount', value: 'totalConcession', align: 'center' })
      }
      header.push({ text: 'Amount Due', value: 'totalAmountDue', align: 'center' })

      if (this.isGST) {
        if (this.isIGST) {
          header.push({ text: 'IGST', value: 'totalIGST', align: 'center' })
        } else {
          header.push({ text: 'CGST', value: 'totalCGST', align: 'center' })
          header.push({ text: 'SGST', value: 'totalSGST', align: 'center' })
        }
      }
      header.push({ text: 'Amount To Pay', value: 'totalAmountPayable', align: 'center' })
      header.push({ text: '', value: 'data-table-expand' })
      return header
    },
    calculatePayAmount () {
      this.totalAmount = 0
      this.totalAmountDue = 0
      this.totalConcession = 0
      this.totalAmountToPay = 0
      this.totalIGST = 0
      this.totalCGST = 0
      this.totalSGST = 0
      this.checkedRows = []
      _.forEach(this.feeTypeGroup, (item) => {
        item.totalAmount = 0
        item.totalAmountDue = 0
        item.totalConcession = 0
        item.totalAmountPayable = 0
        item.totalCGST = 0
        item.totalSGST = 0
        item.totalIGST = 0
        _.forEach(item.installments, (itemChild, indexChild) => {
          if (item.position > indexChild) {
            itemChild.isChecked = true
            item.totalAmount = this.addTwoNumber(item.totalAmount, itemChild.amount)
            item.totalAmountDue = this.addTwoNumber(item.totalAmountDue, itemChild.amountDue)
            item.totalConcession = this.addTwoNumber(item.totalConcession, itemChild.amountConcession)
            item.totalCGST = this.addTwoNumber(item.totalCGST, itemChild.cGSTAmt)
            item.totalSGST = this.addTwoNumber(item.totalSGST, itemChild.sGSTAmt)
            item.totalIGST = this.addTwoNumber(item.totalIGST, itemChild.iGSTAmt)
            item.totalAmountPayable = this.addTwoNumber(item.totalAmountPayable, itemChild.payableAmt)
            this.checkedRows.push(itemChild.id)
          } else {
            itemChild.isChecked = false
          }
        })
        this.totalAmount = this.addTwoNumber(item.totalAmount, this.totalAmount)
        this.totalAmountDue = this.addTwoNumber(item.totalAmountDue, this.totalAmountDue)
        this.totalConcession = this.addTwoNumber(item.totalConcession, this.totalConcession)
        this.totalIGST = this.addTwoNumber(item.totalIGST, this.totalIGST)
        this.totalCGST = this.addTwoNumber(item.totalCGST, this.totalCGST)
        this.totalSGST = this.addTwoNumber(item.totalSGST, this.totalSGST)
        this.totalAmountToPay = this.addTwoNumber(item.totalAmountPayable, this.totalAmountToPay)
      })
    },
    addTwoNumber (num1, num2) {
      return this.toFixed(Number(num1) + Number(num2))
    },
    toFixed (number, length = 2) {
      return Number(Number(number).toFixed(length))
    },
    captureResponse: async function () {
      try {
        console.log('Captured ', this.orderID)
        this.orderID = ''
        this.loadingComponent = this.$buefy.loading.open()
        const response = await http.post(`${constants.API_URL}/api/service/payment/order`, {
          referenceID: this.referenceID,
          assignServiceFeeComponentID: this.studentInfo.linkGeneratedFor,
          assignFeeInstallmentID: this.checkedRows,
          amount: this.totalAmountToPay
        })
        this.orderID = response.data.orderID

        return response
        // this.Pay(event, response.data)
      } catch (e) {
        await this.reject()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('error in fetching data : ', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.loadingComponent.close()
      }
    },
    Pay: async function (event) {
      console.log('Pay Triggered')
      if (_.isEmpty(this.checkedRows)) {
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: 'Please select at least one installment',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
      if (this.totalAmountToPay <= 0) {
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: 'Minimum amount 1 Rupee for procced',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
      try {
        const resultantObj = await this.captureResponse()

        let self = this
        console.log(resultantObj.data)
        var options = {
          key: `${constants.RAZORPAY.RAZOR_KEY}`, // Enter the Key ID generated from the Dashboard
          amount: this.totalAmountToPay, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
          currency: 'INR',
          name: 'Firstcry Intellitots',
          description: `${constants.RAZORPAY.FEE_TYPE.ADMISSION_FEE}`,
          image: `${constants.RAZORPAY.TOTS_IMAGE}`,
          order_id: resultantObj.data.orderID, // This is a sample Order   ID. Pass the `id` obtained in the response of Step 1
          handler: async function (response) {
            await self.postCapture(response.razorpay_payment_id)
          },
          modal: {
            ondismiss: async function () {
              await self.reject()
            }
          },
          prefill: {
            name: self.studentInfo.fatherName,

            email: self.studentInfo.fatherEmailID || 'SXXXXXXXX@gmail.com',
            contact: self.studentInfo.fatherMobile || '9999999999'
          },
          notes: {
            address: 'Razorpay Corporate Office'
          },
          theme: {
            color: `${constants.RAZORPAY.COLOR}`
          }
        }

        let rzp = new window.Razorpay(options)

        rzp.on('payment.failed', async function (response) {
          await self.reject()
          if (confirm(response.error.reason)) {
            location.reload()
          } else {
            location.reload()
          }

          // if (response && response.error.code && response.error.description) {
          //   alert(`${response.error.code} ${response.error.description}`)
          // } else {
          //   alert('Something Went Wrong ! Please try again')
          // }
        })

        rzp.open()
        event.preventDefault()
      } catch (e) {
        await self.reject()
        self.isError = true

        const errorMessage = (e && e.response && e.response.data.message) || e.message

        console.log('error in fetching data : ', errorMessage)
      }
    },
    postCapture: async function (key) {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        this.sendCaptureRespos = await http.post(`${constants.API_URL}/api/service/payment/capture`, { paymentID: key })
        // this.sendCaptureRespos = await http.get(`${constants.API_URL}/api/invoice/${this.sendCaptureRespos.data.paymentOrderData.id}`)
        this.paymentOrderID = this.sendCaptureRespos.data.paymentOrderData.id
        this.sendCaptureRespos = await http.get(`${constants.API_URL}/api/invoice/${this.sendCaptureRespos.data.paymentOrderData.id}`)
        this.orderID = ''
        this.isSuccess = true
        // this.$router.push({ name: 'invoice' })
      } catch (e) {
        this.isError = true
        this.orderID = ''

        const errorMessage = (e && e.response && e.response.data.message) || e.message

        console.log('error in fetching data : ', errorMessage)
      } finally {
        this.loadingComponent.close()
      }
    },
    getAllInfo: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        let response = await http.get(`${constants.API_URL}/api/service-fee-payment/installments/${this.referenceID}`)
        this.studentInfo = response.data.studentInfo
        const feeTypeData = response.data.feeTypes
        this.feeTypeGroup = feeTypeData.feeTypeGroup
        this.isConcession = feeTypeData.isConcession
        this.gstType = feeTypeData.gstType
        this.isIGST = _.isEqual(feeTypeData.gstType, 'IGST')
        this.isGST = feeTypeData.isGST
        this.calculatePayAmount()
        this.headers = this.getHeaders()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message

        console.log('error in fetching data : ', errorMessage)
        this.isError = true
      } finally {
        this.loadingComponent.close()
      }
    }
  }
}
</script>
